import React from 'react';
import classNames from 'classnames';
import { getTailwindClassByEnum } from '@/utils/cssHelpers';
import { ColumnGapEnum, BackgroundColorEnum } from '@/enums/styling';
import Wave from './wave';
import { WavesEnum } from '@/enums/waves';
import { compose } from '@/utils/story-composer';
import BackgroundImageWrapper from '@/components/wrappers/background-image-wrapper';

function Row({
	column,
	elementProps,
	columnGap,
	backgroundColor,
	container,
	borderOptions,
	backgroundImage,
	pageContext,
}) {
	const backgroundClass = getTailwindClassByEnum(BackgroundColorEnum, backgroundColor);
	const gapClass = getTailwindClassByEnum(ColumnGapEnum, columnGap);
	const showWave = borderOption => borderOptions && borderOptions.includes(borderOption);

	return (
		<BackgroundImageWrapper backgroundImage={backgroundImage} pageContext={pageContext}>
			<div {...elementProps} className={classNames('relative bg-center', backgroundClass)}>
				{showWave(WavesEnum.WAVE_TOP) ? <Wave fillColor={backgroundColor} /> : null}
				<div className={classNames(container ? 'container py-20' : 'w-full')}>
					<section className={classNames('grid grid-cols-6', gapClass)}>{column}</section>
				</div>
				{showWave(WavesEnum.WAVE_BOTTOM) ? <Wave backgroundColor={backgroundColor} /> : null}
			</div>
		</BackgroundImageWrapper>
	);
}

export default Row;

compose('row', Row, { children: ['column'] });
